// import { cookieListeners } from './cookie';
// import { menuListeners } from './menu';

let list = {};

document.addEventListener("DOMContentLoaded", () => {
  // cookieListeners();
  animateMenu();

  const addProductButton = document.getElementById("product-toevoegen");
  if (addProductButton) {
    addProductButton.addEventListener("click", () => {
      addProduct(document.getElementById("product").value);
      document.getElementById("product").value = "";
    });
  }

  const boodschapppenlijst = document.getElementById("boodschappenlijstje");

  if (boodschapppenlijst) {
    boodschapppenlijst.addEventListener("click", e => {
      if (e.target.dataset.action == "+") {
        addProduct(e.target.dataset.item);
      }

      if (e.target.dataset.action == "-") {
        removeProduct(e.target.dataset.item);
      }
    });
  }

  // Event listener versturen
  const verstuurButton = document.getElementById("versturen");
  if (verstuurButton) {
    verstuurButton.addEventListener("click", () => {
      let valid = evalForm();
      if (valid) {
        sendFrom();
      }
    });
  }
});

window.onscroll = () => {
  animateMenu();
};

window.productInput = function(e) {
  if (e.keyCode == 13) {
    addProduct(document.getElementById("product").value);
    document.getElementById("product").value = "";
    return false;
  }
};

function addProduct(product) {
  if (product == "") {
    return;
  }
  if (product in list) {
    list[product] = list[product] + 1;
  } else {
    list[product] = 1;
  }
  renderList();
}

function removeProduct(product) {
  if (product in list) {
    list[product] = list[product] - 1;
  }

  if (list[product] < 1) {
    delete list[product];
  }

  renderList();
}

function renderList() {
  const boodschapppenlijst = document.getElementById("boodschappenlijstje");

  let html = "";

  const entries = Object.entries(list);

  const plus = document.getElementById("product-toevoegen").src;
  const minus = plus.replace("plus", "minus");

  for (const [item, count] of entries) {
    html += '<div class="row flex-between">';
    html += "<div>" + item + "</div>";
    html += '<div class="flex-between">';
    html +=
      '<img src="' + minus + '" data-item="' + item + '"  data-action="-">';
    html += '<div class="text-center w-25">' + count + "</div>";
    html +=
      '<img src="' + plus + '" data-item="' + item + '"  data-action="+">';
    html += "</div>";
    html += "</div>";
  }

  boodschapppenlijst.innerHTML = html;
}

function animateMenu() {
  let menu = document.getElementById("menu-container");

  if (menu) {
    if (window.scrollY > 5) {
      menu.classList.add("shadow");
    } else {
      menu.classList.remove("shadow");
    }
  }
}

function evalForm() {
  let formValid = true;
  document
    .querySelectorAll("input:not(#product):not(#privacy),textarea")
    .forEach(input => {
      let dialog = document.getElementById(input.id + "-dialog");
      if (dialog) {
        dialog.classList.add("hidden");
      }

      if (input.value == "") {
        formValid = false;
        if (dialog) {
          dialog.classList.remove("hidden");
        }
      }
    });

  let dialog = document.getElementById("boodschappenlijstje-dialog");
  dialog.classList.add("hidden");
  if (Object.keys(list).length === 0) {
    formValid = false;
    dialog.classList.remove("hidden");
  }

  dialog = document.getElementById("privacy-dialog");
  dialog.classList.add("hidden");
  if (!document.getElementById("privacy").checked) {
    formValid = false;
    dialog.classList.remove("hidden");
  }

  return formValid;
}

function sendFrom() {
  document.querySelector("#versturen h1").classList.toggle("hidden");
  document
    .querySelector("#versturen .spinner-container")
    .classList.toggle("hidden");
  let form = {};

  form["persoonlijke gegevens"] = {};
  document.querySelectorAll("input,textarea").forEach(input => {
    form["persoonlijke gegevens"][input.name] = input.value;
  });

  form = {
    ...form,
    Boodschappenlijstje: list
  };

  var request = new XMLHttpRequest();
  request.open("POST", ajax_object.ajax_url, true);
  request.setRequestHeader(
    "Content-Type",
    "application/x-www-form-urlencoded; charset=UTF-8"
  );
  request.onload = function() {
    if (this.status >= 200 && this.status < 400) {
      // If successful

      document.querySelector("#versturen h1").classList.toggle("hidden");
      document
        .querySelector("#versturen .spinner-container")
        .classList.toggle("hidden");

      document.querySelector("#versturen h1").innerHTML = "Bedankt!";
      document.getElementById("versturen").classList.add("pointer-events-none");
    }
  };
  request.onerror = function() {
    document.querySelectorAll("#versturen h1").forEach(div => {
      div.classList.toggle("hidden");
    });
    document.querySelector("#versturen h1").innerHTML =
      "Probeer het later nog eens";
    document.getElementById("versturen").classList.add("pointer-events-none");
  };
  request.send(
    "action=boodschappen&data=" +
      encodeURIComponent(
        JSON.stringify({
          form: form
        })
      )
  );
}
